import React, { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import useAuth from "../hooks/useAuth.js";
import useAnalytics from "../hooks/useAnalytics.js";
import csLogo from "../assets/cs-horizontal-logo@3x.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import SideMenu from "../components/SideMenu.js";
import { faBars } from "@fortawesome/pro-solid-svg-icons";
import { useLayout } from "../context/layoutContext.js";
import {
    ActionIcon,
    Box,
    Container,
    Flex,
    Image,
    useMantineTheme,
    Drawer,
} from "@mantine/core";
import { useMediaQuery, useDisclosure } from "@mantine/hooks";

export default function Layout() {
    const { isAuthed } = useAuth();
    const { showSidebar } = useLayout();
    const { trackPageView } = useAnalytics();
    const location = useLocation();

    const [opened, { open, close }] = useDisclosure(false);

    const theme = useMantineTheme();

    const largeScreen = useMediaQuery(`(min-width: ${theme.breakpoints.lg})`);

    // Enable drawer < lg
    const enableDrawer = !largeScreen;

    // Track page views on route changes
    useEffect(() => {
        trackPageView({
            url: window.location.href,
            page_path: location.pathname,
            page_search: location.search,
            page_hash: location.hash,
        });
    }, [location.pathname, location.search, location.hash, trackPageView]);

    return (
        <>
            <Container size={"2xl"}>
                <Flex
                    top="0"
                    display="flex"
                    align={"center"}
                    sx={{ position: "sticky", zIndex: 1 }}
                    bg={"#ffffff"}
                    py={"md"}
                >
                    {showSidebar && enableDrawer && (
                        <Box p="md" display="flex">
                            <ActionIcon
                                onClick={open}
                                color="primary"
                                size="3rem"
                            >
                                <FontAwesomeIcon icon={faBars} size="2xl" />
                            </ActionIcon>
                        </Box>
                    )}
                    {isAuthed && (
                        <Box
                            display="flex"
                            sx={{ justifyContent: "space-between" }}
                        >
                            <Image
                                height={"3.5rem"}
                                src={csLogo}
                                alt="CareSource Logo"
                                fit="contain"
                                maw={"100%"}
                            />
                        </Box>
                    )}
                </Flex>
                <Flex mt={3} direction={{ base: "column", lg: "row" }}>
                    {showSidebar && !enableDrawer && (
                        <Box
                            my={{ base: 4, lg: 0 }}
                            px={{ base: 0, lg: 4 }}
                            sx={{
                                flex: "0 0 350px",
                                alignSelf: "flex-start",
                                position: "sticky",
                                overflow: "hidden",
                            }}
                            display="flex"
                            top="5.5rem"
                            h="calc(100vh - 5.5rem)"
                        >
                            <SideMenu />
                        </Box>
                    )}
                    <Box
                        sx={{
                            flex: "1 2 90%",
                            minWidth: 0,
                        }}
                    >
                        <Outlet />
                    </Box>
                </Flex>
            </Container>
            {showSidebar && enableDrawer && (
                <Drawer opened={opened} onClose={close}>
                    <SideMenu />
                </Drawer>
            )}
        </>
    );
}
